import script from "./password-interrupt-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./password-interrupt-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__